import { render, staticRenderFns } from "./CustomersPage.vue?vue&type=template&id=7a7e738c&scoped=true"
import script from "./CustomersPage.vue?vue&type=script&lang=js"
export * from "./CustomersPage.vue?vue&type=script&lang=js"
import style0 from "./CustomersPage.vue?vue&type=style&index=0&id=7a7e738c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7e738c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7e738c')) {
      api.createRecord('7a7e738c', component.options)
    } else {
      api.reload('7a7e738c', component.options)
    }
    module.hot.accept("./CustomersPage.vue?vue&type=template&id=7a7e738c&scoped=true", function () {
      api.rerender('7a7e738c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/customers/CustomersPage.vue"
export default component.exports